// extracted by mini-css-extract-plugin
export default {"customWrapper":"style_customWrapper__QFXPi","customEditor":"style_customEditor__KEX5M"};